"use client";

import { motion } from "framer-motion";
import ButtonGroup from "@/app/components/ui/ButtonGroup";
import { withBasePath, withMediaUrl } from "@/app/lib/basePath";
import {
  getLanguageFromPathname,
  withLanguagePrefix,
} from "@/app/lib/i18n-routing";
import { fadeUp, stagger } from "@/app/lib/utils/motionVariants";
import Image from "next/image";
import { ArrowRight } from "lucide-react";
import { usePathname } from "next/navigation";
import ProductMedia from "@/app/components/products/ProductMedia";

export default function ProductShowcase({ data }: any) {
  const pathname = usePathname();
  const lang = getLanguageFromPathname(pathname);

  // if (!dashboard) return null;
  if (!data) return null;

   const slide = data;

  const title = slide.title || "";
  const highlight = slide.titleHighlight || "";
  const subtitle = slide.subtitle || "";
  const buttons = slide.buttons || [];  

  return (

    <div className="relative flex flex-col items-center justify-center py-4 md:py-6 lg:py-8">
      <div className="-translate-x-1/2 -z-1 absolute aspect-square left-1/2 max-w-full lg:max-w-[2560px] md:aspect-auto md:min-h-[1000px] pointer-events-none top-0 w-full">
        <div className="shadow-[0_0_120px_110px_rgb(36,91,187),0_0_220px_218px_rgb(36,91,187),0_0_790px_320px_rgb(36,91,187)] h-[0.1px] w-[0.1px] left-1/3 top-1/4 -translate-middle absolute rounded-full backdrop-blur-xl bg-[rgb(22,154,156)] scale-150 opacity-40"></div>
        <div className="absolute -bottom-40 left-0 w-full md:w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 right-0 w-full md:w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full lg:w-[800px] h-[800px] bg-accent/10 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto relative z-10 ">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={stagger}
          className="max-w-4xl mx-auto text-center"
        >
          <motion.h2 variants={fadeUp} className="section-title mb-3">
            {title ? (
              <>
                {title} 
                <span className="banner-highlight-title"> {highlight}</span>
              </>
            ) : (
              title
            )}
          </motion.h2>
          <motion.p
            variants={fadeUp}
            className="section-description"
          >
            {subtitle}
          </motion.p>
          <motion.div variants={fadeUp} className="mt-4 lg:mt-6">
            <ButtonGroup
              containerClass="flex flex-col sm:flex-row gap-4 justify-center"
              buttons={buttons.map((b: any, i: number) => ({
                title: b.title,
                url: b.url,
                target: b.target || "_self",
                variant: i === 0 ? "primary" : "secondary",
                content:
                  i === 0 ? (
                    <>
                      {b.title}
                    </>
                  ) : (
                    b.title
                  ),
              }))}
              localizedPath={(p: string) => withLanguagePrefix(p, lang)}
            />
          </motion.div>
        </motion.div>

        {/* Product Preview */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-5 lg:mt-12"
        >
          <div className="relative">
            {/* <div className="absolute -inset-4 bg-gradient-to-r from-primary/30 to-secondary/30 rounded-3xl blur-2xl w-full md:w-auto" /> */}
            <div className="flex items-center justify-center aspect-video ">
              <ProductMedia media={slide.media || []} />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
